import React, { useEffect, useState } from "react";

import _ from "lodash";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";

import { useDispatch, useSelector } from "react-redux";
import {
  getBrokerageFilterListClear,
  getSurveyListReportResClear,
  getTeamMatesResClear,
} from "../../../redux/assignCourse/actions";

import ChooseProvider from "../../reportFilter/ChooseProvider";
import ChooseOfficePeople from "../../reportFilter/ChooseOfficePeople";
import ChooseManager from "../../reportFilter/ChooseManager";
import ChooseCourse from "../../reportFilter/ChooseCourse";
import ChooseREA from "../../reportFilter/ChooseREA";
import ChooseLp from "../../reportFilter/ChooseLP";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Modal from "react-bootstrap/Modal";
import { saveFilterData } from "../../../redux/reports/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import { Spinner } from "react-bootstrap";
import CONFIG from "../../../utils/config";
import ChooseAgentStatus from "../../AssignModal/ChooseAgentStatus";
import ChooseBrokerage from "../../reportFilter/ChooseBrokerage";
import ConfirmModal from "../../modal/ConfirmModal";
import ChooseSurvey from "../../reportFilter/ChooseSurvey";

const ReportFiltersComponent = (props) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    setIsExpand,
    setSelectedFilters,
    handleClick,
    isMobile,
    isLp,
    showFilters,
    hideOverDueStatus,
    reportType,
    selectedFiltersFromDashboard,
    localFilters,
    setLocalFilters,
  } = props;

  console.log("reportType--", reportType);

  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);

  useEffect(() => {
    if (!_.isEmpty(selectedFiltersFromDashboard)) {
      console.log(
        "selfil-",
        selectedFiltersFromDashboard,
        selectedFiltersFromDashboard?.selectedCourseOrVideo
      );
      setDateRange(selectedFiltersFromDashboard?.dateRange);
      setafterDate(selectedFiltersFromDashboard?.dateRange?.start);
      setbeforeDate(selectedFiltersFromDashboard?.dateRange?.end);
      setSelectedProviderList(
        selectedFiltersFromDashboard?.selectedProviderList
      );
      setSelectedSurveyList(selectedFiltersFromDashboard?.selectedSurveyList);
      setSelectedOfficeList(selectedFiltersFromDashboard?.selectedOfficeList);
      if (
        selectedFiltersFromDashboard?.selectedBrokerageList &&
        Array.isArray(selectedFiltersFromDashboard.selectedBrokerageList)
      ) {
        setSelectedBrokerageList(
          selectedFiltersFromDashboard?.selectedBrokerageList
        );
      }
      setSelectedManagerCoachList(
        selectedFiltersFromDashboard?.selectedManagerCoachList
      );
      setCheck(selectedFiltersFromDashboard?.check);
      setSelectedCourseList(selectedFiltersFromDashboard?.selectedCourseList);
      setSelectedTeamMatesList(
        selectedFiltersFromDashboard?.selectedTeamMatesList
      );
      setSelectedStatus(selectedFiltersFromDashboard?.selectedStatus);
      setSelectedAssignment(selectedFiltersFromDashboard?.selectedAssignment);
      if (selectedFiltersFromDashboard?.selectedStatus?.includes("completed")) {
        setCheckCompleted(true);
      } else {
        setCheckCompleted(false);
      }
      if (selectedFiltersFromDashboard?.selectedStatus?.includes("overdue")) {
        setCheckOverdue(true);
      } else {
        setCheckOverdue(false);
      }
      if (
        selectedFiltersFromDashboard?.selectedStatus?.includes("in-progress")
      ) {
        setCheckInProgress(true);
      } else {
        setCheckInProgress(false);
      }
      if (
        selectedFiltersFromDashboard?.selectedStatus?.includes("not-started")
      ) {
        setCheckYetToStart(true);
      } else {
        setCheckYetToStart(false);
      }

      if (selectedFiltersFromDashboard?.selectedAssignment?.includes("self")) {
        setCheckSelfAssign(true);
      } else {
        setCheckSelfAssign(false);
      }
      if (
        selectedFiltersFromDashboard?.selectedAssignment?.includes("manager")
      ) {
        setCheckManagerAssign(true);
      } else {
        setCheckManagerAssign(false);
      }
      if (
        selectedFiltersFromDashboard?.selectedAssignment?.includes(
          "broker_admin"
        )
      ) {
        setCheckBrokerAssign(true);
      } else {
        setCheckBrokerAssign(false);
      }
      if (selectedFiltersFromDashboard?.selectedAssignment?.includes("api")) {
        setCheckApiAssign(true);
      } else {
        setCheckApiAssign(false);
      }

      // selectedRole: getRoleArr(),
      // setDojRange(selectedFiltersFromDashboard?.dojRange),
      setafterDOJ(selectedFiltersFromDashboard?.dojRange?.start);
      setbeforeDOJ(selectedFiltersFromDashboard?.dojRange?.end);
      setSelectedRoleFilter(selectedFiltersFromDashboard?.selectedRole);
      setSelectedAgentStatusFitler(
        selectedFiltersFromDashboard?.selectedAgentStatus
      );
      setCourseOrVideoSelector(
        selectedFiltersFromDashboard?.selectedCourseOrVideo
      );
      setSelectedFilters(selectedFiltersFromDashboard);
    }
  }, [selectedFiltersFromDashboard]);

  useEffect(() => {
    if (!_.isEmpty(localFilters)) {
      let selected_filters = localFilters;
      console.log("local filter", selected_filters);
      if (
        selected_filters?.selectedBrokerageList &&
        Array.isArray(selected_filters?.selectedBrokerageList)
      ) {
        setSelectedBrokerageList(selected_filters?.selectedBrokerageList);
      }
      setDateRange(selected_filters?.dateRange);
      setafterDate(selected_filters?.dateRange?.start);
      setbeforeDate(selected_filters?.dateRange?.end);
      setSelectedProviderList(selected_filters?.selectedProviderList);
      setSelectedSurveyList(selected_filters?.selectedSurveyList);

      setCheck(selected_filters?.check);
      setTimeout(() => {
        setSelectedOfficeList(selected_filters?.selectedOfficeList);
        setSelectedCourseList(selected_filters?.selectedCourseList);
        setSelectedManagerCoachList(selected_filters?.selectedManagerCoachList);
        setSelectedTeamMatesList(selected_filters?.selectedTeamMatesList);
      }, 2000);
      setSelectedStatus(selected_filters?.selectedStatus);
      if (selected_filters?.selectedStatus?.includes("completed")) {
        setCheckCompleted(true);
      } else {
        setCheckCompleted(false);
      }
      if (selected_filters?.selectedStatus?.includes("overdue")) {
        setCheckOverdue(true);
      } else {
        setCheckOverdue(false);
      }
      if (selected_filters?.selectedStatus?.includes("in-progress")) {
        setCheckInProgress(true);
      } else {
        setCheckInProgress(false);
      }
      if (selected_filters?.selectedStatus?.includes("not-started")) {
        setCheckYetToStart(true);
      } else {
        setCheckYetToStart(false);
      }

      setSelectedAssignment(selected_filters?.selectedAssignment);
      if (selected_filters?.selectedAssignment?.includes("self")) {
        setCheckSelfAssign(true);
      } else {
        setCheckSelfAssign(false);
      }
      if (selected_filters?.selectedAssignment?.includes("manager")) {
        setCheckManagerAssign(true);
      } else {
        setCheckManagerAssign(false);
      }
      if (selected_filters?.selectedAssignment?.includes("broker_admin")) {
        setCheckBrokerAssign(true);
      } else {
        setCheckBrokerAssign(false);
      }
      if (selected_filters?.selectedAssignment?.includes("api")) {
        setCheckApiAssign(true);
      } else {
        setCheckApiAssign(false);
      }
      // selectedRole: getRoleArr(),
      // setDojRange(selectedFiltersFromDashboard?.dojRange),
      setafterDOJ(selected_filters?.dojRange?.start);
      setbeforeDOJ(selected_filters?.dojRange?.end);
      setSelectedRoleFilter(selected_filters?.selectedRole);
      setSelectedAgentStatusFitler(selected_filters?.selectedAgentStatus);
      setCourseOrVideoSelector(selected_filters?.selectedCourseOrVideo);
      // setTimeout(() => {
      // }, 2000);
      // setLocalFilters({})

      setLocalFilters({});
    }
  }, [localFilters]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isCompliance = params.get("isCompliance");

  const [activeKey, setActiveKey] = useState([]);

  const [afterdate, setafterDate] = useState();
  const [beforedate, setbeforeDate] = useState();
  const [officeLabel, setOfficeLabel] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [selectedProviderList, setSelectedProviderList] = useState([]);
  const [selectedSurveyList, setSelectedSurveyList] = useState([]);
  const [selectedOfficeList, setSelectedOfficeList] = useState([]);
  const [selectedBrokerageList, setSelectedBrokerageList] = useState([]);
  const [selectedManagerCoachList, setSelectedManagerCoachList] = useState([]);
  const [check, setCheck] = useState(isCompliance === "0" ? false : true);
  const [courseOrVideoSelector, setCourseOrVideoSelector] = useState(false);
  const [selectedCourseList, setSelectedCourseList] = useState([]);
  const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([]);
  const [checkCompleted, setCheckCompleted] = useState(true);
  const [checkInProgress, setCheckInProgress] = useState(true);
  const [checkOverdue, setCheckOverdue] = useState(true);
  const [checkYetToStart, setCheckYetToStart] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([
    "completed",
    "in-progress",
    "overdue",
    "not-started",
  ]);
  const [checkSelfAssign, setCheckSelfAssign] = useState(true);
  const [checkManagerAssign, setCheckManagerAssign] = useState(true);
  const [checkBrokerAssign, setCheckBrokerAssign] = useState(true);
  const [checkApiAssign, setCheckApiAssign] = useState(true);
  const [selectedAssignment, setSelectedAssignment] = useState([
    "self",
    "manager",
    "broker_admin",
    "api",
  ]);
  // const [selectedRoleFilter, setSelectedRoleFilter] = useState(
  //     ['realtor', 'manager', 'guest', 'instructor', 'all']
  // )
  const [selectedRoleFilter, setSelectedRoleFilter] = useState(
    showFilters.roleFilter?.SystemUsageReports
      ? ["realtor", "manager", "guest", "instructor", "all"]
      : ["realtor", "manager", "guest", "all"]
  );
  const [selectedAgentStatusFilter, setSelectedAgentStatusFitler] = useState([
    1,
  ]);

  useEffect(() => {}, [courseOrVideoSelector]);

  const [checkREA, setCheckREA] = useState(false);
  const [checkManager, setCheckManager] = useState(false);
  const [checkGuest, setCheckGuest] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [selectedRole, setSelectedRole] = useState([]);
  const [afterDOJ, setafterDOJ] = useState();
  const [beforeDOJ, setbeforeDOJ] = useState();
  const [dojRange, setDojRange] = useState({ start: "", end: "" });
  const [savedFilters, setSavedFilters] = useState({});

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      // alert(JSON.stringify(authBroker.payload.user.config))
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        authBroker.payload?.user?.is_corporate
          ? setOfficeLabel(`${authBroker.payload?.user?.config.office_name}`)
          : setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        authBroker.payload?.user?.is_corporate
          ? setOfficeLabel("Offices")
          : setOfficeLabel("Offices");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        authIframeBroker.payload?.user?.is_corporate
          ? setOfficeLabel(
              `${authIframeBroker.payload?.user?.config.office_name}`
            )
          : setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        authIframeBroker.payload?.user?.is_corporate
          ? setOfficeLabel("Offices")
          : setOfficeLabel("Offices");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    console.log("selected dates", afterDOJ, beforeDOJ);
    setDojRange({ start: afterDOJ, end: beforeDOJ });
  }, [beforeDOJ, afterDOJ]);

  useEffect(() => {
    console.log("selected dates", afterdate, beforedate);
    setDateRange({ start: afterdate, end: beforedate });
  }, [afterdate, beforedate]);

  const setFilterReqFunc = () => {
    if (dateRange?.start && !dateRange?.end) {
      setConfirmModal(true);
      return;
    } else if (!dateRange?.start && dateRange?.end) {
      setConfirmModal(true);
      return;
    }
    let tempFilterObj = {
      dateRange: dateRange,
      selectedProviderList: selectedProviderList,
      selectedOfficeList: selectedOfficeList,
      selectedBrokerageList: selectedBrokerageList,
      selectedManagerCoachList: selectedManagerCoachList,
      check: check,
      selectedCourseList: selectedCourseList,
      selectedTeamMatesList: selectedTeamMatesList,
      selectedStatus: getStatusArr(),
      selectedAssignment: getAssignmentFromArray(),
      // selectedRole: getRoleArr(),
      dojRange: dojRange,
      selectedRole: selectedRoleFilter,
      selectedAgentStatus: selectedAgentStatusFilter,
      selectedCourseOrVideo: courseOrVideoSelector,
      clickedApply: true,
      selectedSurveyList: selectedSurveyList,
    };
    setSelectedFilters(tempFilterObj);
    setSavedFilters(tempFilterObj);
    if (window.location.pathname.includes("systemusage")) {
      handleClick();
    }
    console.log("filters applied", tempFilterObj);
  };

  useEffect(() => {
    console.log("SELECTED STATUS", selectedStatus);
  }, [selectedStatus]);

  useEffect(() => {
    console.log("SELECTED ASSIGNMENT", selectedAssignment);
  }, [selectedAssignment]);

  useEffect(() => {
    console.log("SELECTED Role", selectedRole);
  }, [selectedRole]);

  useEffect(() => {
    console.log("learning content type", courseOrVideoSelector);
  }, [courseOrVideoSelector]);

  useEffect(() => {
    getStatusArr();
  }, [checkCompleted, checkInProgress, checkOverdue, checkYetToStart]);

  useEffect(() => {
    getStatusArr();
  }, [checkSelfAssign, checkManagerAssign, checkBrokerAssign, checkApiAssign]);

  useEffect(() => {
    getRoleArr();
  }, [checkREA, checkManager, checkGuest]);

  useEffect(() => {
    console.log("isCompliance: ", isCompliance);
    if (isCompliance === "0") {
      setCheck(false);
    }
  }, [isCompliance]);

  const expandCollapseAccord = (key) => {
    if (activeKey.includes(key)) {
      const index = activeKey.indexOf(key);
      if (index > -1) {
        //only splice array when item is found
        let tempArr = _.cloneDeep(activeKey);
        tempArr.splice(index, 1); //2nd parameter means remove one item only
        setActiveKey(tempArr);
      }
    } else {
      let tempArr = _.cloneDeep(activeKey);
      tempArr.push(key);
      setActiveKey(tempArr);
    }
  };

  const getStatusArr = () => {
    let statusArr = [];
    if (checkCompleted) {
      statusArr.push("completed");
    }
    if (!showFilters?.surveyStatus && checkInProgress) {
      statusArr.push("in-progress");
    }
    if (checkOverdue && !hideOverDueStatus) {
      statusArr.push("overdue");
    }
    if (checkYetToStart) {
      statusArr.push("not-started");
    }
    setSelectedStatus(statusArr);
    return statusArr;
  };

  const getAssignmentFromArray = () => {
    let assignArray = [];
    if (checkSelfAssign) {
      assignArray.push("self");
    }
    if (checkManagerAssign) {
      assignArray.push("manager");
    }
    if (checkBrokerAssign) {
      assignArray.push("broker_admin");
    }
    if (checkApiAssign) {
      assignArray.push("api");
    }
    setSelectedAssignment(assignArray);
    return assignArray;
  };

  const getRoleArr = () => {
    let roleArr = [];
    if (checkREA) {
      roleArr.push("REA");
    }
    if (checkGuest) {
      roleArr.push("Guest");
    }

    if (checkManager) {
      roleArr.push("Manager");
    }
    setSelectedRole(roleArr);
    return roleArr;
  };

  const handleDateChange = (date) => {
    // Format the date to MM/DD/YYYY before setting it in the state
    date.setHours(0, 0, 0, 0);
    const formattedDate = format(date, "MM/dd/yyyy");
    return formattedDate;
  };

  const handleBeforeDateChange = (date) => {
    setbeforeDOJ(handleDateChange(date));
  };

  const handleStartDateChange = (date) => {
    console.log("date---", beforedate, handleDateChange(date));
    if (beforedate) {
      const startDateObj = new Date(beforedate.split("/").reverse().join("/"));
      const endDateObj = new Date(
        handleDateChange(date).split("/").reverse().join("/")
      );

      if (endDateObj > startDateObj) {
        setReportingDateError(
          "Start date should be lesser or equal to end date"
        );
        return;
      } else {
        setReportingDateError("");
      }
    }
    setafterDate(handleDateChange(date));
  };

  const [reportingDateError, setReportingDateError] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);

  useEffect(() => {
    if (!afterdate && !beforedate) {
      setReportingDateError("");
    }
  }, [afterdate, beforedate]);

  const handleEndDateChange = (date) => {
    console.log("date---", afterdate, handleDateChange(date));
    // (MM/DD/YYYY format)
    if (afterdate) {
      const startDateObj = new Date(afterdate.split("/").reverse().join("/"));
      const endDateObj = new Date(
        handleDateChange(date).split("/").reverse().join("/")
      );

      if (endDateObj < startDateObj) {
        setReportingDateError(
          "End date should be greater or equal to start date"
        );
        return;
      } else {
        setReportingDateError("");
      }
    }

    setbeforeDate(handleDateChange(date));
  };

  const handleAfterDateChange = (date) => {
    setafterDOJ(handleDateChange(date));
  };

  const handleOptionChange = (event) => {
    let courseOrVideo = event.target.value === "Video" ? true : false;
    setCourseOrVideoSelector(courseOrVideo);
  };

  const [savedFiltersTitle, setSavedFiltersTitle] = useState("");

  const [isSaveLoading, setIsSaveLoading] = useState(false);

  const saveFilterDataRes = useSelector((state) => state.report.saveFilterData);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  useEffect(() => {
    console.log("saveFilterDataRes", saveFilterDataRes);
    if (!_.isEmpty(saveFilterDataRes)) {
      if (saveFilterDataRes?.status === "success") {
        setIsSaveLoading(false);
        setFormSuccess("Saved successfully!");
        setTimeout(() => {
          setFormSuccess("");
          cancelSavingFilters();
        }, 2000);
      } else {
        setIsSaveLoading(false);
        setFormError("Failed to save, try again!");
        setTimeout(() => {
          setFormError("");
        }, 3000);
      }
    }
  }, [saveFilterDataRes]);

  const saveFilters = () => {
    setIsSaveLoading(true);
    let tempFilterObj = {
      dateRange: dateRange,
      selectedProviderList: selectedProviderList,
      selectedOfficeList: selectedOfficeList,
      selectedBrokerageList: selectedBrokerageList,
      selectedManagerCoachList: selectedManagerCoachList,
      check: check,
      selectedCourseList: selectedCourseList,
      selectedTeamMatesList: selectedTeamMatesList,
      selectedStatus: getStatusArr(),
      selectedAssignment: getAssignmentFromArray(),
      // selectedRole: getRoleArr(),
      dojRange: dojRange,
      selectedRole: selectedRoleFilter,
      selectedAgentStatus: selectedAgentStatusFilter,
      selectedCourseOrVideo: courseOrVideoSelector,
      selectedSurveyList: selectedSurveyList,
    };
    // setSavedFilters(tempFilterObj);

    dispatch(
      saveFilterData({
        module: "saveFilterData",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          title: savedFiltersTitle,
          report_type: reportType,
          filter_content: tempFilterObj,
        },
      })
    );
  };

  const cancelSavingFilters = () => {
    setModalShow(false);
    setSavedFiltersTitle("");
    setFormError("");
  };

  const saveFilteresFunc = () => {
    let obj = { message: "scrollToTop" };
    isMobile
      ? window.parent.postMessage(
          JSON.stringify(obj),
          CONFIG.API_URL_BROKER_ADMIN
        )
      : window.scrollTo(0, 0);
    setModalShow(true);
  };

  return (
    <>
      <section className="filter-box-reports">
        <div className="filter-box-header d-flex justify-content-between">
          <div
            className="filter-head-left cursor-pointer"
            onClick={() => {
              setIsExpand(false);
            }}
          >
            <svg
              fill="#000000"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              width="18px"
              height="18px"
              viewBox="0 0 971.986 971.986"
            >
              <g>
                <path
                  d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                                c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
                                c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
                />
              </g>
            </svg>
            Filters
          </div>
          <div className="filter-apply-right">
            <div
              className="expand-filter"
              data-bs-target=".multi-collapse"
              aria-expanded="false"
              aria-controls="multiCollapseExample1 multiCollapseExample2"
              onClick={() => {
                setActiveKey([
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  "10",
                  "11",
                  "12",
                ]);
              }}
            >
              Expand All
            </div>
            <div
              className="expand-filter"
              onClick={() => {
                setActiveKey([]);
              }}
            >
              Collapse All
            </div>
          </div>
        </div>
        <div className="filter-options-report">
          <Accordion
            className="row"
            defaultActiveKey={activeKey}
            alwaysOpen
            activeKey={activeKey}
          >
            {showFilters.reportingPeriod ? (
              <Accordion.Item eventKey="0" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("0");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {!_.isEmpty(dateRange.start) ? (
                    <strong>Reporting Period (1)</strong>
                  ) : (
                    "Reporting Period"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  {/* <DateRangePicker dayPlaceholder="DD" monthPlaceholder="MM" yearPlaceholder="YYYY" maxDate={new Date()} onChange={(evt) => {
                                console.log('dateRangeselected:', evt)
                                let dateRangeObj = { start: "", end: "" }
                                if (evt !== null) {
                                    dateRangeObj = { start: moment(evt[0]).format("MM/DD/YYYY"), end: moment(evt[1]).format("MM/DD/YYYY") }
                                }
                                setDateRange(dateRangeObj)
                            }}
                                value={[dateRange.start, dateRange.end]}
                            /> */}
                  <div className="date-pick-box" id="report-date">
                    <div className="input-text position-relative d-flex">
                      <label htmlFor="date_join" className="input__label">
                        Start
                      </label>
                      <DatePicker
                        selected={afterdate ? new Date(afterdate) : null}
                        placeholderText="MM/DD/YYYY"
                        className="input__field02"
                        maxDate={new Date()}
                        defaultDate="MM/DD/YYYY"
                        onChange={(date) => handleStartDateChange(date)}
                        required
                      />
                      {afterdate && (
                        <svg
                          onClick={() => setafterDate()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          stroke="black"
                          strokeWidth="2"
                          class="react-daterange-picker__clear-button__icon react-daterange-picker__button__icon"
                        >
                          <line x1="4" x2="15" y1="4" y2="15"></line>
                          <line x1="15" x2="4" y1="4" y2="15"></line>
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="date-pick-box">
                    <div className="input-text position-relative d-flex">
                      <label htmlFor="date_join" className="input__label">
                        End
                      </label>
                      <DatePicker
                        selected={beforedate ? new Date(beforedate) : null}
                        placeholderText="MM/DD/YYYY"
                        className="input__field02"
                        maxDate={new Date()}
                        defaultDate="MM/DD/YYYY"
                        onChange={(date) => handleEndDateChange(date)}
                        required
                      />
                      {beforedate && (
                        <svg
                          onClick={() => setbeforeDate()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          stroke="black"
                          strokeWidth="2"
                          class="react-daterange-picker__clear-button__icon react-daterange-picker__button__icon"
                        >
                          <line x1="4" x2="15" y1="4" y2="15"></line>
                          <line x1="15" x2="4" y1="4" y2="15"></line>
                        </svg>
                      )}
                    </div>
                  </div>
                  {reportingDateError && (
                    <div id="date-error" style={{ color: "red" }}>
                      {reportingDateError}
                    </div>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.provider ? (
              <Accordion.Item eventKey="1" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("1");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedProviderList?.length > 0 ? (
                    <strong>Provider ({selectedProviderList?.length})</strong>
                  ) : (
                    "Provider"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseProvider
                    parentId={""}
                    parentName={"course"}
                    selectedProviderList={selectedProviderList}
                    setSelectedProviderList={setSelectedProviderList}
                    isMobile={isMobile}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.brokerages ? (
              <Accordion.Item eventKey="11" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("11");
                    dispatch(getBrokerageFilterListClear());
                  }}
                >
                  {selectedBrokerageList?.length > 0 ? (
                    <strong>
                      Brokerages ({selectedBrokerageList?.length})
                    </strong>
                  ) : (
                    "Brokerages"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseBrokerage
                    selectedBrokerageList={selectedBrokerageList}
                    setSelectedBrokerageList={setSelectedBrokerageList}
                    isMobile={isMobile}
                    isLp={isLp}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.offices ? (
              <Accordion.Item eventKey="2" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("2");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedOfficeList?.length > 0 ? (
                    <strong>
                      {officeLabel} ({selectedOfficeList?.length})
                    </strong>
                  ) : (
                    `${officeLabel}`
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseOfficePeople
                    selectedOfficeList={selectedOfficeList}
                    setSelectedOfficeList={setSelectedOfficeList}
                    isMobile={isMobile}
                    selectedBrokerageList={selectedBrokerageList}
                    isLp={isLp}
                    officeLabel={officeLabel}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {/* {showFilters.role ? <Accordion.Item eventKey="8" className="multi-collapse col-md-6">
                        <Accordion.Header onClick={() => { 
                            expandCollapseAccord("8"); 
                            dispatch(getTeamMatesResClear()) 
                        }}>
                            {selectedRole?.length > 0 ? 
                            <strong>Role ({selectedRole?.length})</strong> :
                             "Role"}
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="select-status">
                                <div className="form-check cursor-pointer">
                                    <input className="form-check-input cursor-pointer" type="checkbox" 
                                        checked={checkREA}
                                        onChange={() => {
                                            if (checkREA)
                                            {
                                                setCheckREA(false)
                                                setCheckAll(false)
                                            
                                            }
                                            else 
                                            {
                                                setCheckREA(true)
                                                if(checkGuest && checkManager)
                                                {
                                                    setCheckAll(true)
                                                }
                                            }
                                        }} />
                                    <label className="form-check-label cursor-pointer" for="termofusein">REA</label>
                                </div>
                                <div className="form-check cursor-pointer">
                                    <input className="form-check-input cursor-pointer" type="checkbox" 
                                        checked={checkManager}
                                        onChange={() => {
                                            if (checkManager)
                                            {
                                                setCheckManager(false)
                                                setCheckAll(false)
                                            }
                                            else 
                                            {
                                                setCheckManager(true)
                                                if(checkGuest && checkREA)
                                                {
                                                    setCheckAll(true)
                                                }
                                            }
                                        }} />
                                    <label className="form-check-label cursor-pointer" for="termofusein">Manager</label>
                                </div>
                               
                                <div className="form-check cursor-pointer">
                                    <input className="form-check-input cursor-pointer" type="checkbox" 
                                        checked={checkGuest}
                                        onChange={() => {
                                            if (checkGuest)
                                            {
                                                setCheckGuest(false)
                                                setCheckAll(false)
                                            }
                                            else 
                                            {
                                            setCheckGuest(true)
                                            if(checkREA && checkManager)
                                                {
                                                    setCheckAll(true)
                                                }
                                            }
                                        }} />
                                    <label className="form-check-label cursor-pointer" for="termofusein">Guest</label>
                                </div>
                                <div className="form-check cursor-pointer">
                                    <input className="form-check-input cursor-pointer" type="checkbox" 
                                        checked={checkAll}
                                        onChange={() => {
                                            if (checkAll)
                                            {
                                                setCheckREA(false)
                                                setCheckManager(false)
                                                setCheckGuest(false)
                                                setCheckAll(false)
                                            }
                                            else 
                                            {
                                                setCheckREA(true)
                                                setCheckManager(true)
                                                setCheckGuest(true)
                                                setCheckAll(true)
                                            }
                                        }} />
                                    <label className="form-check-label cursor-pointer" for="termofusein">All</label>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item> : ""} */}
            {showFilters.reportingTo ? (
              <Accordion.Item eventKey="3" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("3");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedManagerCoachList?.length > 0 ? (
                    <strong>
                      Reporting to ({selectedManagerCoachList?.length})
                    </strong>
                  ) : (
                    "Reporting to"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseManager
                    parentId={""}
                    parentName={"course"}
                    selectedManagerCoachList={selectedManagerCoachList}
                    setSelectedManagerCoachList={setSelectedManagerCoachList}
                    isMobile={isMobile}
                    selectedBrokerageList={selectedBrokerageList}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.learningContentType ? (
              <Accordion.Item eventKey="4" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("4");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {check ? (
                    <strong>Learning Content Type (1)</strong>
                  ) : (
                    "Learning Content Type"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="select-status">
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="radio"
                        // checked={check}
                        // onChange={() => {
                        //     if (check)
                        //         setCheck(false)
                        //     else setCheck(true)
                        //     setSelectedCourseList([])
                        // }}
                        value="Video"
                        checked={courseOrVideoSelector ? true : false}
                        onChange={handleOptionChange}
                      />
                      {/* <label className="form-check-label cursor-pointer" for="termofusein">{isLp ? "Onboarding" : "Compliance"}</label> */}
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Video
                      </label>
                    </div>
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="radio"
                        // checked={check}
                        // onChange={() => {
                        //     if (check)
                        //         setCheck(false)
                        //     else setCheck(true)
                        //     setSelectedCourseList([])
                        // }}
                        value="Course"
                        checked={courseOrVideoSelector ? false : true}
                        onChange={handleOptionChange}
                      />
                      {/* <label className="form-check-label cursor-pointer" for="termofusein">{isLp ? "Onboarding" : "Compliance"}</label> */}
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Course
                      </label>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.learningContent ? (
              <Accordion.Item eventKey="5" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("5");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedCourseList?.length > 0 ? (
                    <strong>
                      Learning Content ({selectedCourseList?.length})
                    </strong>
                  ) : (
                    "Learning Content"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  {isLp ? (
                    <ChooseLp
                      parentId={""}
                      parentName={"Courses"}
                      selectedLpList={selectedCourseList}
                      setSelectedLpList={setSelectedCourseList}
                      isOnboard={check ? 1 : 0}
                      isMobile={isMobile}
                      selectedBrokerageList={selectedBrokerageList}
                    />
                  ) : (
                    <ChooseCourse
                      parentId={""}
                      parentName={courseOrVideoSelector ? "Videos" : "Courses"}
                      selectedCourseList={selectedCourseList}
                      courseOrVideoSelector={courseOrVideoSelector}
                      setSelectedCourseList={setSelectedCourseList}
                      isCompliance={check ? 1 : 0}
                      isMobile={isMobile}
                      selectedBrokerageList={selectedBrokerageList}
                    />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters?.survey ? (
              <Accordion.Item eventKey="13" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("13");
                  dispatch(getSurveyListReportResClear());
                  }}
                >
                  {selectedSurveyList?.length > 0 ? (
                    <strong>Survey ({selectedSurveyList?.length})</strong>
                  ) : (
                    "Survey"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseSurvey
                    parentId={""}
                    selectedSurveyList={selectedSurveyList}
                    setSelectedSurveyList={setSelectedSurveyList}
                    isMobile={isMobile}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.agents ? (
              <Accordion.Item eventKey="6" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("6");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedTeamMatesList?.length > 0 ? (
                    <strong>Agent ({selectedTeamMatesList?.length})</strong>
                  ) : (
                    "Agent"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseREA
                    parentId={""}
                    parentName={"course"}
                    selectedTeamMatesList={selectedTeamMatesList}
                    setSelectedTeamMatesList={setSelectedTeamMatesList}
                    selectedBrokerageList={selectedBrokerageList}
                    isMobile={isMobile}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.agentStatus ? (
              <Accordion.Item eventKey="7" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("7");
                  }}
                >
                  {selectedAgentStatusFilter?.length > 0 ? (
                    <strong>
                      Agent Status ({selectedAgentStatusFilter?.length})
                    </strong>
                  ) : (
                    "Agent Status"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <ChooseAgentStatus
                    parentId={""}
                    parentName={"course"}
                    selectedAgentStatus={selectedAgentStatusFilter}
                    setSelectedAgentStatus={setSelectedAgentStatusFitler}
                    isMobile={isMobile}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.status ? (
              <Accordion.Item eventKey="8" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("8");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedStatus?.length > 0 ? (
                    <strong>Status ({selectedStatus?.length})</strong>
                  ) : (
                    "Status"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="select-status">
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkCompleted}
                        onChange={() => {
                          if (checkCompleted) setCheckCompleted(false);
                          else setCheckCompleted(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Completed
                      </label>
                    </div>
                    {!showFilters?.surveyStatus && (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={checkInProgress}
                          onChange={() => {
                            if (checkInProgress) setCheckInProgress(false);
                            else setCheckInProgress(true);
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          In Progress
                        </label>
                      </div>
                    )}
                    {hideOverDueStatus || showFilters?.survey_status ? (
                      ""
                    ) : (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={checkOverdue}
                          onChange={() => {
                            if (checkOverdue) setCheckOverdue(false);
                            else setCheckOverdue(true);
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          Overdue
                        </label>
                      </div>
                    )}
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkYetToStart}
                        onChange={() => {
                          if (checkYetToStart) setCheckYetToStart(false);
                          else setCheckYetToStart(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Yet to start
                      </label>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
            {showFilters.dojBrokerage ? (
              <Accordion.Item eventKey="9" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("9");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {afterDOJ || beforeDOJ ? (
                    <strong>Date of Joining </strong>
                  ) : (
                    "Date of Joining"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="date-pick-box">
                    <div className="input-text position-relative d-flex">
                      <label htmlFor="date_join" className="input__label">
                        After
                      </label>
                      <DatePicker
                        selected={afterDOJ ? new Date(afterDOJ) : null}
                        placeholderText="MM/DD/YYYY"
                        className="input__field02"
                        maxDate={new Date()}
                        defaultDate="MM/DD/YYYY"
                        onChange={(date) => handleAfterDateChange(date)}
                      />
                      {afterDOJ && (
                        <svg
                          onClick={() => setafterDOJ()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          stroke="black"
                          strokeWidth="2"
                          class="react-daterange-picker__clear-button__icon react-daterange-picker__button__icon"
                        >
                          <line x1="4" x2="15" y1="4" y2="15"></line>
                          <line x1="15" x2="4" y1="4" y2="15"></line>
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="date-pick-box">
                    <div className="input-text position-relative d-flex">
                      <label htmlFor="date_join" className="input__label">
                        Before
                      </label>
                      <DatePicker
                        selected={beforeDOJ ? new Date(beforeDOJ) : null}
                        placeholderText="MM/DD/YYYY"
                        className="input__field02"
                        maxDate={new Date()}
                        defaultDate="MM/DD/YYYY"
                        onChange={(date) => handleBeforeDateChange(date)}
                      />
                      {beforeDOJ && (
                        <svg
                          onClick={() => setbeforeDOJ()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          stroke="black"
                          strokeWidth="2"
                          class="react-daterange-picker__clear-button__icon react-daterange-picker__button__icon"
                        >
                          <line x1="4" x2="15" y1="4" y2="15"></line>
                          <line x1="15" x2="4" y1="4" y2="15"></line>
                        </svg>
                      )}
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}

            {showFilters.role ? (
              <Accordion.Item eventKey="10" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("10");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedRoleFilter?.length > 0 ? (
                    <strong>Role ({selectedRoleFilter?.length})</strong>
                  ) : (
                    "Role"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="select-status">
                    {showFilters.roleFilter.rea ? (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={selectedRoleFilter.includes("realtor")}
                          onChange={() => {
                            let roleFilter = _.cloneDeep(selectedRoleFilter);
                            if (selectedRoleFilter.includes("realtor")) {
                              if (roleFilter.includes("all"))
                                roleFilter.splice(roleFilter.indexOf("all"), 1);
                              roleFilter.splice(
                                roleFilter.indexOf("realtor"),
                                1
                              );
                              console.log(roleFilter);
                              setSelectedRoleFilter(roleFilter);
                            } else {
                              roleFilter.push("realtor");
                              if (
                                window.location.pathname.includes(
                                  "systemusage-report"
                                )
                              ) {
                                // If the condition is true
                                if (
                                  roleFilter.includes("manager") &&
                                  roleFilter.includes("guest") &&
                                  roleFilter.includes("instructor")
                                ) {
                                  roleFilter.push("all");
                                }
                              } else {
                                // If the condition is false
                                if (
                                  roleFilter.includes("manager") &&
                                  roleFilter.includes("guest")
                                ) {
                                  roleFilter.push("all");
                                }
                              }

                              setSelectedRoleFilter(roleFilter);
                            }
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          Real Estate Agent
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showFilters.roleFilter.manager ? (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={selectedRoleFilter.includes("manager")}
                          onChange={() => {
                            let roleFilter = _.cloneDeep(selectedRoleFilter);
                            if (selectedRoleFilter.includes("manager")) {
                              if (roleFilter.includes("all"))
                                roleFilter.splice(roleFilter.indexOf("all"), 1);
                              roleFilter.splice(
                                roleFilter.indexOf("manager"),
                                1
                              );
                              console.log(roleFilter);
                              setSelectedRoleFilter(roleFilter);
                            } else {
                              roleFilter.push("manager");
                              if (
                                window.location.pathname.includes(
                                  "systemusage-report"
                                )
                              ) {
                                // If the condition is true
                                if (
                                  roleFilter.includes("realtor") &&
                                  roleFilter.includes("guest") &&
                                  roleFilter.includes("instructor")
                                ) {
                                  roleFilter.push("all");
                                }
                              } else {
                                // If the condition is false
                                if (
                                  roleFilter.includes("realtor") &&
                                  roleFilter.includes("guest")
                                ) {
                                  roleFilter.push("all");
                                }
                              }
                              setSelectedRoleFilter(roleFilter);
                            }
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          Manager
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showFilters.roleFilter.guest ? (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={selectedRoleFilter.includes("guest")}
                          onChange={() => {
                            let roleFilter = _.cloneDeep(selectedRoleFilter);
                            console.log(roleFilter);
                            if (selectedRoleFilter.includes("guest")) {
                              if (roleFilter.includes("all"))
                                roleFilter.splice(roleFilter.indexOf("all"), 1);
                              console.log(roleFilter);
                              roleFilter.splice(roleFilter.indexOf("guest"), 1);
                              console.log(roleFilter);
                              setSelectedRoleFilter(roleFilter);
                            } else {
                              roleFilter.push("guest");
                              if (
                                window.location.pathname.includes(
                                  "systemusage-report"
                                )
                              ) {
                                // If the condition is true
                                if (
                                  roleFilter.includes("manager") &&
                                  roleFilter.includes("realtor") &&
                                  roleFilter.includes("instructor")
                                ) {
                                  roleFilter.push("all");
                                }
                              } else {
                                // If the condition is false
                                if (
                                  roleFilter.includes("manager") &&
                                  roleFilter.includes("realtor")
                                ) {
                                  roleFilter.push("all");
                                }
                              }
                              setSelectedRoleFilter(roleFilter);
                            }
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          Guest
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showFilters.roleFilter.instructor ? (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={selectedRoleFilter.includes("instructor")}
                          onChange={() => {
                            let roleFilter = _.cloneDeep(selectedRoleFilter);
                            console.log(roleFilter);
                            if (selectedRoleFilter.includes("instructor")) {
                              if (roleFilter.includes("all"))
                                roleFilter.splice(roleFilter.indexOf("all"), 1);
                              console.log(roleFilter);
                              roleFilter.splice(
                                roleFilter.indexOf("instructor"),
                                1
                              );
                              console.log(roleFilter);
                              setSelectedRoleFilter(roleFilter);
                            } else {
                              roleFilter.push("instructor");

                              if (
                                roleFilter.includes("manager") &&
                                roleFilter.includes("guest") &&
                                roleFilter.includes("realtor")
                              ) {
                                roleFilter.push("all");
                              }

                              setSelectedRoleFilter(roleFilter);
                            }
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          External Instructor
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {showFilters.roleFilter.all ? (
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={selectedRoleFilter.includes("all")}
                          onChange={(e) => {
                            console.log(e);
                            let roleFilter = _.cloneDeep(selectedRoleFilter);
                            console.log(roleFilter);
                            if (selectedRoleFilter.includes("all")) {
                              console.log("PRINT");
                              console.log(roleFilter);
                              //roleFilter.splice(roleFilter.indexOf('all'), 1)
                              roleFilter = [];
                              setSelectedRoleFilter(roleFilter);
                            } else {
                              roleFilter.push("all");
                              if (!roleFilter.includes("realtor"))
                                roleFilter.push("realtor");
                              if (!roleFilter.includes("manager"))
                                roleFilter.push("manager");
                              if (!roleFilter.includes("guest"))
                                roleFilter.push("guest");
                              if (showFilters.roleFilter?.SystemUsageReports) {
                                if (!roleFilter.includes("instructor"))
                                  roleFilter.push("instructor");
                              }
                              setSelectedRoleFilter(roleFilter);
                            }
                          }}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          ALL
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}

            {showFilters.assignmentFrom ? (
              <Accordion.Item eventKey="12" className="multi-collapse col-md-6">
                <Accordion.Header
                  onClick={() => {
                    expandCollapseAccord("12");
                    dispatch(getTeamMatesResClear());
                  }}
                >
                  {selectedAssignment?.length > 0 ? (
                    <strong>
                      Assignment From ({selectedAssignment?.length})
                    </strong>
                  ) : (
                    "Assignment From"
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="select-status">
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkSelfAssign}
                        onChange={() => {
                          if (checkSelfAssign) setCheckSelfAssign(false);
                          else setCheckSelfAssign(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Self
                      </label>
                    </div>
                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkManagerAssign}
                        onChange={() => {
                          if (checkManagerAssign) setCheckManagerAssign(false);
                          else setCheckManagerAssign(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Manager
                      </label>
                    </div>

                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkBrokerAssign}
                        onChange={() => {
                          if (checkBrokerAssign) setCheckBrokerAssign(false);
                          else setCheckBrokerAssign(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        Brokerage
                      </label>
                    </div>

                    <div className="form-check cursor-pointer">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        checked={checkApiAssign}
                        onChange={() => {
                          if (checkApiAssign) setCheckApiAssign(false);
                          else setCheckApiAssign(true);
                        }}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        for="termofusein"
                      >
                        API
                      </label>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              ""
            )}
          </Accordion>
          <div className="btn-sec-filter-report gap-3">
            {!showFilters.brokerages && (
              <button
                type="button"
                class="btn btn-primary-complete"
                onClick={() => saveFilteresFunc()}
              >
                Save Filters
              </button>
            )}
            <button
              type="button"
              class="btn btn-primary-complete"
              onClick={() => {
                setFilterReqFunc();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </section>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered={isMobile ? false : true}
        show={modalShow}
        onHide={() => cancelSavingFilters()}
        className="alert-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Save Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body invalidemailshowfp">
          <div className="form-apply">
            {formError ? (
              <div className="notmsg" style={{ color: "red" }}>
                {formError}
              </div>
            ) : (
              ""
            )}
            {formSuccess ? (
              <div className="notmsg" style={{ color: "green" }}>
                {formSuccess}
              </div>
            ) : (
              ""
            )}
            <div class="input-text position-relative">
              <label htmlFor="filternametitle" class="input__label">
                Please Enter Title
              </label>
              <input
                type="text"
                id="filternametitle"
                name="filternametitle"
                class="input__field"
                placeholder=" "
                value={savedFiltersTitle}
                onChange={(evt) => setSavedFiltersTitle(evt.target.value)}
                required
              />
            </div>
            <div className="notmsg">
              This report will be availbale in your dashboard.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button class="btn-primary" onClick={() => cancelSavingFilters()}>
            Cancel
          </button>
          <button
            class="btn-primary"
            onClick={() => saveFilters()}
            disabled={_.isEmpty(savedFiltersTitle)}
          >
            {isSaveLoading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Save"
            )}
          </button>
        </Modal.Footer>
      </Modal>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={
          "Both start and end dates are required for Reporting period filter"
        }
        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
      />
    </>
  );
};

export default ReportFiltersComponent;
